export const PLANNED_TRANSACTIONS_BASE_KEY = 'planned-transactions';

export const plannedTransactionsApiQueryKeys = {
  all: () => [PLANNED_TRANSACTIONS_BASE_KEY] as const,
  byId: (id: string) => [PLANNED_TRANSACTIONS_BASE_KEY, id] as const,
};
